module.exports = "/wwwroot/img/cooperation_logo_block.png?ver=492bb36d";